<template>
  <div
    v-if="hasNewAndUsedAdvisers"
    class="adviser-role-toggle d-inline-flex align-items-center me-4"
    style="gap: 1rem"
  >
    <Popper hover arrow class="fs-5 align-self-center" placement="bottom">
      <template #content>
        <span v-html="newTooltip"></span>
      </template>
      <label
        class="form-check-label small"
        for="flexSwitchCheckDefault"
        v-html="$t('adviser_appointment_type.adviser_role_toggle.labels.new')"
      ></label>
    </Popper>
    <div class="form-check form-switch d-flex align-items-center" style="margin-right: -1.2rem">
      <input
        class="form-check-input"
        type="checkbox"
        v-model="showUsedAdviser"
        id="flexSwitchCheckDefault"
      />
    </div>
    <Popper hover arrow class="fs-5 align-self-center" placement="bottom">
      <template #content>
        <span v-html="usedTooltip"></span>
      </template>
      <label
        class="form-check-label small"
        for="flexSwitchCheckDefault"
        v-html="$t('adviser_appointment_type.adviser_role_toggle.labels.used')"
      ></label>
    </Popper>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { useAppointmentStore } from '~conciergeUiCommons/store/appointmentStore'
import { wTrans } from 'laravel-vue-i18n'

export default defineComponent({
  name: 'AdviserRoleToggle',
  setup() {
    const appointmentStore = useAppointmentStore()
    return {
      appointmentStore
    }
  },
  computed: {
    showUsedAdviser: {
      get(): boolean {
        return this.appointmentStore.showUsedAdviser
      },
      set(value: boolean) {
        this.appointmentStore.showUsedAdviser = value
      }
    },
    hasNewAndUsedAdvisers(): boolean {
      return this.appointmentStore.hasNewAndUsedAdvisers
    },
    newTooltip(): string {
      return wTrans('adviser_appointment_type.adviser_role_toggle.tooltips.new')?.value ?? ''
    },
    usedTooltip(): string {
      return wTrans('adviser_appointment_type.adviser_role_toggle.tooltips.used')?.value ?? ''
    }
  }
})
</script>

<style scoped>
.form-check-input,
.form-check-label {
  cursor: pointer;
}
.form-check-input:focus,
.form-check-input:active,
.form-check-input:checked {
  background-color: #ffffff;
  border-color: #ffffff;
  filter: unset;
}
.form-check-input:focus-visible {
  box-shadow: none;
}
.form-switch .form-check-input,
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='inherit'/%3e%3c/svg%3e");
}
</style>
